// extracted by mini-css-extract-plugin
module.exports = {"button":"_2MipV","button_label":"_2RXJs"};